<template>
    <div class="container mb-5">
        <div class="form-candidate">
            <div class="text-center">
                <div >
                    <img src="../../img/polyana_logo_final-03_1.png" class="img-fluid" alt="">
                </div>
                <h1>Анкета кандидата</h1>
                <div class="block-text mt-4 mb-4">
                    Игорная зона <a href="https://krasnayapolyana.game/" target="_blank">«Красная Поляна»</a> представлена тремя игорными заведениями: 
                    <a href="https://casinosochi.ru/" target="_blank">«Казино Сочи»</a>, 
                    казино <a href="https://casinoboomerang.ru/" target="_blank">«Бумеранг»</a> 
                    и зал игровых автоматов <a href="https://bonushall.ru/" target="_blank">«Бонус Slots»</a>. 
                    На территории игорной зоны расположены также спортивно-развлекательная площадка <a href="https://redarena.ru/" target="_blank">RED ARENA</a>, 
                    <a href="https://bonus-hotel.ru/" target="_blank">Апарт-отель «Бонус»</a>, 
                    собственный театр «Velvet» и несколько ресторанов.
                    Будем рады видеть вас в нашей команде! Заполните анкету, чтобы мы могли рассмотреть вашу кандидатуру.
                </div>
            </div>
            <form @submit.prevent method="post" v-if="!isFormLoading && !success">
                <div class="row g-3">
                    <div class="col-lg mb-3">
                        <label for="lastName" class="form-label">Фамилия</label>
                        <input 
                            v-focus 
                            type="text" 
                            class="form-control" 
                            id="lastName"
                            v-model.trim="v$.candidate.lastName.$model"
                            :class="{ 'input-invalid': v$.candidate.lastName.required.$invalid, 
                            'input-valid': v$.candidate.lastName.$dirty && !v$.candidate.lastName.$error}"
                        >
                        <div
                            v-show="v$.candidate.lastName.alpha.$invalid"
                            class="error-text"
                        >
                            Неверный формат, только буквы.
                        </div>
                        <div
                            v-if="v$.candidate.lastName.required.$invalid"
                            class="error-text"
                        >
                            Обязательно для заполнения.
                        </div>
                        <div
                            v-if="v$.candidate.lastName.minLength.$invalid"
                            class="error-text"
                        >
                            Не менее 2х символов.
                        </div>
                        <div
                            v-if="v$.candidate.lastName.maxLength.$invalid"
                            class="error-text"
                        >
                            Не более 25 символов.
                        </div>
                    </div>
                    <div class="col-lg mb-3">
                        <label for="firstName" class="form-label">Имя</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            id="firstName" 
                            v-model.trim="v$.candidate.firstName.$model"
                            :class="{ 'input-invalid': v$.candidate.firstName.required.$invalid, 
                            'input-valid': v$.candidate.firstName.$dirty && !v$.candidate.firstName.$error }"
                        >
                        <div
                            v-show="v$.candidate.firstName.alpha.$invalid"
                            class="error-text"
                        >
                            Неверный формат, только буквы.
                        </div>
                        <div
                            v-if="v$.candidate.firstName.required.$invalid"
                            class="error-text"
                        >
                            Обязательно для заполнения.
                        </div>
                        <div
                            v-if="v$.candidate.firstName.minLength.$invalid"
                            class="error-text"
                        >
                            Не менее 2х символов.
                        </div>
                        <div
                            v-if="v$.candidate.firstName.maxLength.$invalid"
                            class="error-text"
                        >
                            Не более 25 символов.
                        </div>
                    </div>
                    <div class="col-lg mb-3">
                        <label for="middleName" class="form-label">Отчество</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            id="middleName" 
                            v-model.trim="candidate.middleName"
                            :class="{ 'input-invalid': v$.candidate.middleName.$error, 
                            'input-valid': v$.candidate.middleName.$dirty && !v$.candidate.middleName.$error }"
                        >
                        <div
                            v-show="v$.candidate.middleName.alpha.$invalid"
                            class="error-text"
                        >
                            Неверный формат, только буквы.
                        </div>
                        <div
                            v-if="v$.candidate.middleName.minLength.$invalid"
                            class="error-text"
                        >
                            Не менее {{ v$.candidate.middleName.minLength.$params.min }}х символов.
                        </div>
                        <div
                            v-if="v$.candidate.middleName.maxLength.$invalid"
                            class="error-text"
                        >
                            Не более {{ v$.candidate.middleName.maxLength.$params.max }} символов.
                        </div>
                    </div>
                </div>
                <div class="row g-3">
                    <div class="col-lg mb-3">
                        <label for="bithDay" class="form-label">Дата рождения</label>
                        <input 
                            type="date" 
                            class="form-control" 
                            id="bithDay" 
                            :min="candidate.minDate" :max="candidate.maxDate"
                            v-model.trim="candidate.bithDay"
                            :class="{ 'input-invalid': v$.candidate.bithDay.$silentErrors.length > 0, 
                            'input-valid': v$.candidate.bithDay.$silentErrors.length <= 0 }"
                        >
                        <div
                            v-if="v$.candidate.bithDay.required.$invalid"
                            class="error-text"
                        >
                            Обязательно для заполнения.
                        </div>
                        <div 
                            v-if="v$.candidate.bithDay.valueDateMax.$invalid"
                            class="error-text">
                            Некорректная дата. Друг, ты слишком молод
                        </div>
                        <div 
                            v-if="v$.candidate.bithDay.valueDateMin.$invalid"
                            class="error-text">
                            Некорректная дата. Друг, ты слишком стар
                        </div>
                    </div>
                    <div class="col-lg mb-3">
                        <label class="form-label" for="country">Гражданство</label>
                        <select class="form-control" v-model="candidate.country">
                            <option disabled value=""> Выберите страну </option>
                            <option 
                                v-for="country in countries" 
                                :key="country.id" 
                                :value="country.name"
                            >
                                {{ country.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg mb-3">
                        <label for="phoneNumber" class="form-label">Номер телефона</label>
                        <input 
                            type="tel" 
                            class="form-control" id="phoneNumber" 
                            placeholder="8XXXXXXXXXX"
                            v-model.trim="candidate.phoneNumber"
                            :class="{ 'input-invalid': v$.candidate.phoneNumber.$silentErrors.length > 0, 
                            'input-valid': v$.candidate.phoneNumber.$silentErrors.length <= 0 }"
                        >
                        <div
                            v-if="v$.candidate.phoneNumber.required.$invalid"
                            class="error-text"
                        >
                            Обязательно для заполнения.
                        </div>
                        <div
                            v-if="v$.candidate.phoneNumber.numeric.$invalid"
                            class="error-text"
                        >
                            Неверный формат, только цифры.
                        </div>
                        <div
                            v-if="v$.candidate.phoneNumber.minLength.$invalid"
                            class="error-text"
                        >
                            Минимум {{ v$.candidate.phoneNumber.minLength.$params.min }} цифры.
                        </div>
                        <div
                            v-if="v$.candidate.phoneNumber.maxLength.$invalid"
                            class="error-text"
                        >
                            Максимум {{ v$.candidate.phoneNumber.maxLength.$params.max }} цифр.
                        </div>
                    </div>
                </div>
                <h4 class="mt-3 text-center mb-2">
                    Хочешь быть в центре событий?<br>
                    Стань частью нашей команды!
                </h4>
                <div id="v-model-multiple-checkboxes">
                    <div class="form-check form-switch mt-3">
                        <input class="form-check-input" type="checkbox" role="switch" id="checkRestaurant" value="Ресторанная служба" v-model="candidate.checkedDepartments">
                        <label class="form-check-label" for="checkRestaurant">Ресторанная служба</label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="checkCleaning" value="Клининг" v-model="candidate.checkedDepartments">
                        <label class="form-check-label" for="checkCleaning">Клининг</label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="checkSpg" value="Служба приема гостей" v-model="candidate.checkedDepartments">
                        <label class="form-check-label" for="checkSpg">Служба приема гостей</label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="checkPlayHall" value="Игровой зал" v-model="candidate.checkedDepartments">
                        <label class="form-check-label" for="checkPlayHall">Игровой зал</label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="checkOffice" value="Работа в офисе" v-model="candidate.checkedDepartments">
                        <label class="form-check-label" for="checkOffice">Работа в офисе</label>
                    </div>
                    <div class="form-check form-switch mb-3">
                        <input class="form-check-input" type="checkbox" role="switch" id="checkPractice" value="Практика" v-model="candidate.checkedDepartments">
                        <label class="form-check-label" for="checkPractice">Практика</label>
                    </div>
                </div>
    
                <div class="col-lg mb-3">
                    <label for="inputVacancy" class="form-label">Желаемая должность</label>
                    <input 
                        type="text" 
                        class="form-control" 
                        id="inputVacancy" 
                        v-model.trim="candidate.inputVacancy"
                        :class="{ 'input-invalid': v$.candidate.inputVacancy.$silentErrors.length > 0, 
                        'input-valid': v$.candidate.inputVacancy.$silentErrors.length <= 0 }"
                    >
                    <div
                        v-show="v$.candidate.inputVacancy.alphaNum.$invalid"
                        class="error-text"
                    >
                        Неверный формат, только буквы и цифры.
                    </div>
                    <div
                        v-if="v$.candidate.inputVacancy.minLength.$invalid"
                        class="error-text"
                    >
                        Не менее {{ v$.candidate.inputVacancy.minLength.$params.min }}х символов.
                    </div>
                    <div
                        v-if="v$.candidate.inputVacancy.maxLength.$invalid"
                        class="error-text"
                    >
                        Не более {{ v$.candidate.inputVacancy.maxLength.$params.max }} символов.
                    </div>
                    <div
                        v-if="v$.candidate.inputVacancy.required.$invalid"
                        class="error-text"
                    >
                        Обязательно для заполнения.
                    </div>
                </div>
                <div class="col-lg mb-3">
                    <label 
                        for="description" 
                        class="form-label">
                        Последние 2 места работы
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                        </svg>
                    </label>
                    <textarea 
                        v-model.trim="candidate.description" 
                        class="form-control" 
                        id="description" 
                        placeholder="Даты, Компания, Должность"
                        :class="{ 'input-invalid': v$.candidate.description.$silentErrors.length > 0, 
                        'input-valid': v$.candidate.description.$silentErrors.length <= 0 }"
                    > 
                    </textarea>
                    <div
                        v-if="v$.candidate.description.required.$invalid"
                        class="error-text"
                    >
                        Обязательно для заполнения.
                    </div>
                    <div 
                        v-if="v$.candidate.description.minLength.$invalid"
                        class="error-text"
                    >  
                        Не менее {{ v$.candidate.description.minLength.$params.min }} символов.
                    </div>
                    <div 
                        v-if="v$.candidate.description.maxLength.$invalid"
                        class="error-text"
                    >  
                        Не более {{ v$.candidate.description.maxLength.$params.max }} символов.
                    </div>
                    <div
                        v-show="v$.candidate.description.alphaNum.$invalid"
                        class="error-text"
                    >
                        Недопустимый символ.
                    </div>
                </div>
                <div class="mb-3 form-check mb-3">
                    <input 
                        type="checkbox" 
                        class="form-check-input" 
                        id="checkPdn" 
                        v-model="candidate.checkPdn"
                        :class="{ 'check-invalid': v$.candidate.checkPdn.$silentErrors.length > 0, 
                        'check-valid': v$.candidate.checkPdn.$silentErrors.length <= 0 }"
                    >
                    <label class="form-check-label" for="checkPdn">Согласие на обработку персональных данных. </label>
                    <span><a href="https://www.do-mein.ru/personal-data-policy/" target="_blank"> Политика обработки персональных данных.</a></span>
                    <div 
                        v-show="v$.candidate.checkPdn.sameAs.$invalid"
                        class="error-text"
                    >
                        Необходимо согласиться с обработкой персональных данных.
                    </div>
                </div>
                <vue-recaptcha
                    ref="recaptcha"
                    size="invisible"
                    :sitekey="sitekey"
                    :loading-timeout="loadingTimeout"
                    @verify="sendForm"
                    @expired="onCaptchaExpired"
                ></vue-recaptcha>
                <button 
                    v-if="v$.candidate.$silentErrors.length <= 0 && !loading" 
                        @click="validateForm" 
                        type="submit" 
                        class="btn btn-dark w-100"
                    >
                    Отправить
                </button>
                <button v-else-if="v$.candidate.$silentErrors.length <= 0 && loading" 
                    class="btn btn-dark w-100" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="visually-hidden">Загрузка...</span>
                </button>
                <button 
                    v-else
                        :disabled="v$.candidate.$silentErrors.length > 0"
                        type="submit" 
                        class="btn btn-dark w-100"
                    >
                    Отправить
                </button>
            </form>
            <div v-show="isFormLoading" class="text-center mt-5 mb-5">
                <div class="spinner-grow text-danger" style="--bs-spinner-width: 5rem;--bs-spinner-height: 5rem;" role="status">

                </div>
                <div class="visually-show">Подождите идет загрузка ...</div>
            </div>
            <div v-show="success" class="alert alert-success mt-3 text-center" role="alert">
                <h3>{{ successfuly.msg }}</h3>
                <p>Для повторной отправки анкеты, обновите страницу.</p>
            </div>
            <div v-show="errored" class="alert alert-danger mt-3" role="alert">
                <h3>{{ errorsFeed.msg }}</h3>
                <ul>
                    <li 
                        v-for="error in errorsFeed.errors"
                        :key="error.id" 
                    >
                    {{ error }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import axios from 'axios';
    import { useVuelidate } from '@vuelidate/core'
    import { required, minLength, maxLength, numeric, sameAs } from '@vuelidate/validators'
    import vueRecaptcha from 'vue3-recaptcha2';

    export default {
        components: { vueRecaptcha },
        data() {
            return {
                candidate: {
                    lastName: '',
                    firstName: '',
                    middleName: '',
                    bithDay: null,
                    checkPdn: '',
                    phoneNumber: '',
                    inputVacancy: '',
                    country: '',
                    checkedDepartments: [],
                    description: '',
                    maxDate: null,
                    minDate: null,
                },
                countries: [],
                isFormLoading: true,
                loading: false,
                errored: false,
                errorsFeed: [],
                success: false,
                successfuly: '',
                sitekey: '6LfAzacnAAAAAOF4so0HILkTFotXgVTgJWHBF-ih',
		loadingTimeout: 30000
            };
        },
        validations() {
            return {
                candidate: {
                    lastName: { 
                        required,
                        minLength: minLength(2),
                        maxLength: maxLength(25),
                        alpha: val => /^[a-zA-Zа-яА-Я]*$/i.test(val), 
                    },
                    firstName: { 
                        required,
                        minLength: minLength(2),
                        maxLength: maxLength(25),
                        alpha: val => /^[a-zA-Zа-яА-Я]*$/i.test(val),  
                    },
                    middleName: { 
                        minLength: minLength(2),
                        maxLength: maxLength(25),
                        alpha: val => /^[a-zA-Zа-яА-Я]*$/i.test(val),  
                    },
                    bithDay: {
                        required,
                        valueDateMin(val, { minDate }) {
                            // console.log(new Date(minDate))
                            return val === "" || new Date(val) > new Date(minDate)
                        },
                        valueDateMax(val, { maxDate }) {
                            return val === "" || new Date(val) <= new Date(maxDate)
                        }
                    },
                    phoneNumber: { 
                        numeric,
                        required,
                        minLength: minLength(4),
                        maxLength: maxLength(15),
                    },
                    inputVacancy: { 
                        required,
                        minLength: minLength(4),
                        maxLength: maxLength(50),
                        alphaNum: val => /^[a-zA-Zа-яА-Я\s\d\w-]*$/i.test(val),
                    },
                    description: { 
                        required,
                        minLength: minLength(25),
                        maxLength: maxLength(200),
                        alphaNum: val => /^[a-zA-Zа-яА-Я\s\d\w-.,]*$/i.test(val),
                    },
                    checkPdn: { 
                        sameAs: sameAs(true)
                    }
                }
            }
        },
        setup() {
            return { v$: useVuelidate() }
        },
        methods: {
            async getCountries() {
                try {
                    this.isFormLoading = true;
                    const response = await axios.get('https://form.do-mein.ru/api/v1/');
                    this.countries = response.data;
                    const $script = document.createElement('script')
                    $script.async = true
                    $script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
                    document.head.appendChild($script)
                }
                catch (e) {
                    //console.log('error');
                }
                finally {
                    this.isFormLoading = false;
                }
            },
            async sendForm(recaptchaToken) {        
                try {    
                    this.loading = true; 
                    this.errored = false;  
                    this.isFormLoading = true;  
                    //const body = JSON.stringify(this.candidate, recaptchaToken);
                    const response = await axios.post('https://form.do-mein.ru/api/v1/', {
                        lastName: this.candidate.lastName,
                        firstName: this.candidate.firstName,
                        middleName: this.candidate.middleName,
                        bithDay: this.candidate.bithDay,
                        checkPdn: this.candidate.checkPdn,
                        phoneNumber: this.candidate.phoneNumber,
                        inputVacancy: this.candidate.inputVacancy,
                        country: this.candidate.country,
                        checkedDepartments: this.candidate.checkedDepartments,
                        description: this.candidate.description,
                        recaptchaToken: recaptchaToken
                    })
                    this.successfuly = response.data;
                    this.success = true;
                }
                catch(error) {
                    this.errored = true;
                    this.success = false;
                    this.errorsFeed = error.response.data;
                }
                finally {
                    this.loading = false;
                    this.isFormLoading = false;
                }
                    //this.errored = false;
                    //this.success = false;
            },
            minMaxDate() {
                var today = new Date();
                var currDate = today.getDate();
                var currMonth = today.getMonth() + 1;
                var currYear = today.getFullYear();
                let monthType = currMonth < 10 ? '0' + currMonth : currMonth;
                let dateType = currDate < 10 ? '0' + currDate : currDate;
                this.candidate.maxDate = (currYear - 18) + "-" + monthType + "-" + dateType;
                this.candidate.minDate = (currYear - 70) + "-" + monthType + "-" + dateType;       
            },
            validateForm() {
                this.$refs.recaptcha.execute()
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset()
            }
        },
    
        mounted() {
            this.getCountries();
            this.minMaxDate();
            //('#v-model-multiple-checkboxes');
        }
    }
    </script>
    
    <style scoped>
    .form-candidate {
        background: #F4F5FA;
        border: 2px solid;
        border-radius: 30px;
        padding: 5%;
        margin: 50px 10px;
    }
    .input-invalid {
        border-color: var(--bs-form-invalid-border-color);
        padding-right: calc(1.5em + 0.75rem);
        background-image: url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e);
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
    .input-valid {
        border-color: var(--bs-form-valid-border-color);
        padding-right: calc(1.5em + 0.75rem);
        background-image: url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e);
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
    .error-text {
        margin-top: 0.25rem;
        font-size: 0.875em;
        color: var(--bs-form-invalid-color);
    }
    </style>